<template>

  <div>
    <!--活动列表-->
    <Project v-if="activeName == 'project'"></Project>
    <ProjectUser v-if="activeName == 'projectuser'"></ProjectUser>
    <Type v-if="activeName == 'type'"></Type>
    <!--活动核销-->
    <!-- <Invest v-if="activeName == 'invest'"></Invest> -->
    <!--活动设置-->
    <!-- <Setting v-if="activeName == 'setting'"></Setting> -->
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Project from './project/index';
import Invest from './invest/index';
import Setting from './setting/getSetting.vue';
import ProjectUser  from './project/user';
import Type  from './type/index';
export default {
  components: {
    Project,
    Invest,
    Setting,
    ProjectUser,
    Type
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'project',
      /*切换数组*/
      sourceList: [
        {
          key: 'project',
          value: '项目列表',
          path:'/plus/project/project/index'
        },
        {
          key: 'projectuser',
          value: '合作人员',
          path:'/plus/project/project/user'
        },
        {
          key: 'type',
          value: '类型',
          path:'/plus/project/type/index'
        },
        // {
        //   key: 'invest',
        //   value: '投资列表',
        //   path:'/plus/project/invest/index'
        // },
        // {
        //   key: 'setting',
        //   value: '项目设置',
        //   path:'/plus/project/setting/getSetting'
        // },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {
 
    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'project',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'project'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/project/index.vue